'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './memoryGame.routes';

function Tile(title) {
  this.title = title;
  this.flipped = false;

  this.flip = function() {
    this.flipped = !this.flipped;
  }
}

function Game(fnSaveResult, tileNames) {
  let tileDeck = makeDeck(tileNames);

  this.grid = makeGrid(tileDeck);
  this.message = Game.MESSAGE_CLICK;
  this.unmatchedPairs = tileNames.length;
  this.firstAction = true;
  this.saveResult = fnSaveResult;

  this.flipTile = function(tile) {
    if (tile.flipped) {
      return;
    }

    if (this.firstAction) {
      this.startTime = new Date();
      this.firstAction = false;
    }

    tile.flip();

    if (!this.firstPick || this.secondPick) {

      if (this.secondPick) {
        this.firstPick.flip();
        this.secondPick.flip();
        this.firstPick = this.secondPick = undefined;
      }

      this.firstPick = tile;
      this.message = Game.MESSAGE_ONE_MORE;

    } else {

      if (this.firstPick.title === tile.title) {
        this.unmatchedPairs--;
        this.message = (this.unmatchedPairs > 0) ? Game.MESSAGE_MATCH : Game.MESSAGE_WON;
        this.firstPick = this.secondPick = undefined;

        if (this.unmatchedPairs == 0) {
          // User has won
          let time = (new Date() - this.startTime) / 1000;
          this.saveResult(time);
        }
      } else {
        this.secondPick = tile;
        this.message = Game.MESSAGE_MISS;
      }
    }
  }
}

Game.MESSAGE_CLICK = 'Click on a tile.';
Game.MESSAGE_ONE_MORE = 'Pick one more card.';
Game.MESSAGE_MISS = 'Try again.';
Game.MESSAGE_MATCH = 'Good job! Keep going.';
Game.MESSAGE_WON = 'You win!';

/* Create an array with two of each tileName in it */
function makeDeck(tileNames) {
  let tileDeck = [];
  tileNames.forEach(function(name) {
    tileDeck.push(new Tile(name));
    tileDeck.push(new Tile(name));
  });

  return tileDeck;
}


function makeGrid(tileDeck) {
  let grid = [],
    deckLength = tileDeck.length;

  for (let i = 0; i < deckLength; i++) {
    let tile = removeRandomTile(tileDeck);
    grid.push(tile);
  }

  return grid;
}


function removeRandomTile(tileDeck) {
  let i = Math.floor(Math.random()*tileDeck.length);
  return tileDeck.splice(i, 1)[0];
}

export class MemoryGameComponent {
  constructor(Auth, LeaderboardService) {
    'ngInject';
    this.LeaderboardService = LeaderboardService;

    this.getLeaderboard();

    let fnSaveResult = (time) => {
      LeaderboardService.save({
        game: 'memory',
        flavor: '9pairs',
        time: time,
        meta: {
          creationUser: Auth.getCurrentUserSync()._id
        }
      }, () => {
        this.getLeaderboard();
      });
    };

    this.game = new Game(fnSaveResult, ['balcony', 'books','cactus','livingroom','palm','skyline','surf','wine','work']);
  }

  getLeaderboard() {
    this.LeaderboardService.getByGameAndFlavor({game: 'memory', flavor:'9pairs'}, data => {
      this.leaderboard = data;
    });
  }

}

export default angular.module('conduuApp.memoryGame', [uiRouter])
  .config(routes)
  .component('memoryGame', {
    template: require('./memoryGame.html'),
    controller: MemoryGameComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/games/memory/memoryGame.component.js